export default "__VITE_ASSET__f81ddebc__"